import { auth } from "./auth";

/** The sign-in callback, landing on the intake form when no page was remembered. */
export const CallbackPage = auth.CallbackPage;
